<template>
  <o-form-wrapper v-model="item" :form-state="formState" :schema="schema" :server-errors="_se" :v="$v.item">
    <o-widget-wrapper :form-state="formState" :schema="schema" :server-errors="_se" :validators="$v.item"
                      name="code">
      <o-text-field
        v-model="item.code"

        :form-state="formState"
        :server-errors="_se" :validators="$v.item" name="code" v-bind="schema.fields.code"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper :form-state="formState" :schema="schema" :server-errors="_se" :validators="$v.item"
                      name="description">
      <o-text-field
        v-model="item.description"

        :form-state="formState"
        :server-errors="_se" :validators="$v.item" name="description" v-bind="schema.fields.description"
      ></o-text-field>
    </o-widget-wrapper>

  </o-form-wrapper>
</template>

<script>
import schema from "../../schema/index";
import {cleanUpModel} from "../../../vue-ocom/schema/schema_vuetify";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin
} from '../../../vue-ocom/mixins'
import {validationMixin} from 'vuelidate'
import OWidgetWrapper from "../../../vue-ocom/components/forms/OWidgetWrapper";
import OTextField from "../../../vue-ocom/components/forms/fields/OTextField";
import OSelect from "../../../vue-ocom/components/forms/fields/OSelect";
import OCheckbox from "../../../vue-ocom/components/forms/fields/OCheckbox";
import OFormWrapper from "../../../vue-ocom/components/forms/OFormWrapper";
import ODateTime from "../../../vue-ocom/components/forms/fields/ODateTime";


export default {
  mixins: [VuelidateMixin,
    validationMixin,
    CreateFormStateMixin('$v'),
    CreateGroupPermissionMixin('CodeFileType'),
    CreateCodeTableFetchMixin([])
  ],
  components: {
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,

    OCheckbox,
    OSelect,
    OTextField,

  },
  props: {
    item: {
      type: Object, default: () => {
      }
    },
    level: {type: Number, default: 0},
    inModal: {type: Boolean, default: false},
  },
  data: () => ({
    schemaModel: cleanUpModel(schema.CodeFileType, {}),
  }),
  methods: {},
  computed: {
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    }
  },
  watch: {},
  created() {
  },
}
</script>
